import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-general',
  templateUrl: './home-general.component.html',
  styleUrls: ['./home-general.component.css']
})
export class HomeGeneralComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
